import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Typography, IconButton,Button} from '@mui/material';
import { Search as SearchIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL'; 
import AddUserDialog from '../Contents/AdminUser/AddAdminUserDialog';
import SetPaymentRegisterForm from '../Contents/SetPayment/SetPaymentRegisterForm';
import Earns from '../Contents/pay/Earns';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const Pay = () => {

  
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [StudentData,setStudentData] = useState(null)
  const [CountData,setCountData] = useState(0)
  const rowsPerPage = 6;
  const {setLoader,accesstoken,RefreshUesFF} = useContext(ContextData)

  useEffect(()=>{
      

      async function FetchData(){
              //  setLoader(true)  

            try {
              const response = await axios.get(`${baseUrl}/auth/get_data_user`,{
                withCredentials: true,
                headers: {
                  'Accept' : 'application/json',
                  'authorization': `Bearer ${accesstoken !== null && accesstoken}`
                }}) 

              setCountData(Object.keys(response.data))
              setStudentData(response.data)
              setLoader(false)
             
            } catch (err) {
               if(err) console.log(err.message)
              // setLoader(false)
            }

           
      }FetchData()  


  },[RefreshUesFF])

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };


  
    const List =  Object.keys(StudentData !== null && StudentData).map(data=> StudentData[data])
    const filteredUsers = List.filter(user => {
    const lowerCaseSearchText = searchText.toLowerCase().trim();
    return (
        (
         user.fname.toLowerCase().includes(lowerCaseSearchText) &&   user.lname.toLowerCase().includes(lowerCaseSearchText) ) ||
         user.mobile.toLowerCase().includes(lowerCaseSearchText) ||
         user.email.toLowerCase().includes(lowerCaseSearchText) ||
         user.profession.toLowerCase().includes(lowerCaseSearchText) ||
         user.stateoforigin.toLowerCase().includes(lowerCaseSearchText)
         // Add more fields for search if needed (e.g., state, phone number)
       );

  });

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handleNextPage = () => {
    setCurrentPage(prevPage => prevPage + 1);  
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => prevPage - 1);
  };

  const HanldeRemove = async (sttokens) =>{

    
    try {
      const response = await axios.delete(`${""}/auth/delete_student/${sttokens}`,{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`
        }})
          } catch (err) {

       if(err) console.log(err.message)
      
       }

  }



  return (
    <div  className="con-dev" style={{width:"100%",height:"100%"}}>
    <Container
    >
      <Typography variant="h4" gutterBottom className='flex justify-between items-center'>
        <p className='font-extrabold mt-3'>Pay</p>
        <div>
          <SetPaymentRegisterForm />
        </div>
      </Typography>
      
      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{background:"rgb(0, 24, 69)"}}>
            <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>No</TableCell>
            <TableCell  align='center' sx={{color:"white",fontWeight:"800"}}>State</TableCell>
            <TableCell  align='center' sx={{color:"white",fontWeight:"800"}}>Full Name</TableCell>
            <TableCell  align='center' sx={{color:"white",fontWeight:"800"}}>Email</TableCell>
            <TableCell  align='center' sx={{color:"white",fontWeight:"800"}}>Earns</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usersToShow.map((user,index) => (
                    
              <TableRow key={user.id}>

                 <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{index + 1}</TableCell>

                 <TableCell align='center'>
                  {user.stateoforigin}
                 </TableCell>

                 <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.fname} {user.lname}</TableCell>
                 <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.email}</TableCell>
    
                 <TableCell align='center'>

                  <Earns token={user.token} />

                  </TableCell> 
                  
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {totalPages > 1 && (
        <div>
          {currentPage > 1 && (
      <Button className='Hover-' onClick={handlePrevPage} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(0, 24, 69)', color:"white", margin:'9px 4px'}}  size="large" variant="contained">
      <ArrowBackIcon />
      </Button>
          )}
          <span>Page {currentPage} of {totalPages}</span>
          {currentPage < totalPages && (
             <Button className='Hover-' onClick={handleNextPage} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(0, 24, 69)', color:"white", margin:'9px 4px'}}  size="large" variant="contained">
                 <ArrowForwardIcon />
           </Button>
            
          )}
          
        </div>
      )}
    </Container>
    </div>
  );
};

export default Pay;


// get_data_adminuser